export const FEATURE_FLAG_KEYS = [
    'scraper_beta',
    'analytics_experimental',
    'audiences_v1',
    'automations_v1',
    'campaign_metrics_v2',
    'step_experiments_v1',
    'reply_classification_v1',
    'reply_classification_actions_v1',
    'copilot_v1',
    'copilot_read_tools_v1',
];
export const FEATURE_FLAG_LABELS = {
    scraper_beta: 'Scraper (beta)',
    analytics_experimental: 'Analytics (experimenteel)',
    audiences_v1: 'Doelgroepen (v1)',
    automations_v1: 'Automations (v1)',
    campaign_metrics_v2: 'Campagne KPI v2 (excl. tests, reply-definitie)',
    step_experiments_v1: 'Step-level A/B (varianten per sequence-stap)',
    reply_classification_v1: 'Reply-classificatie (regels + AI, shadow standaard)',
    reply_classification_actions_v1: 'Reply-classificatie: automatische acties (niet shadow)',
    copilot_v1: 'Copilot (chat-assistent, read-first; apart van automations_v1)',
    copilot_read_tools_v1: 'Copilot read-only tools (campagnes, doelgroepen, GA4/GSC)',
};
//# sourceMappingURL=featureFlagKeys.js.map